import "./portfolio.scss"
function Portfolio() {
  return (
    
    <div className="fotogallery">
     <p>раздел в разработке</p>
    </div>
  );
}

export default Portfolio;